import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/inbox',
        name: 'inbox',
        component: () => import('@/pages/inbox/InboxIndex.vue'),
        meta: {
            title: 'Inbox',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'messages' },
            dataTablePage: true,
        },
        beforeEnter: FeatureMiddleware('INBOX'),
    },
    {
        path: '/inbox/messages',
        name: 'inbox-messages',
        component: () => import('@/components/inbox/messages/MessagesViewAll.vue'),
        meta: {
            title: 'Messages',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'messages' },
        },
        beforeEnter: FeatureMiddleware('INBOX') && FeatureMiddleware('MESSAGES'),
    },
    {
        path: '/inbox/messages/:messageId/',
        name: 'message-view',
        component: () => import('@/components/inbox/messages/MessageView.vue'),
        props: true,
        meta: {
            title: 'Message',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'messages' },
        },
        beforeEnter: FeatureMiddleware('INBOX') && FeatureMiddleware('MESSAGES'),
    },
    {
        path: '/inbox/discussions',
        name: 'inbox-discussions',
        component: () => import('@/components/inbox/discussions/DiscussionsViewAll.vue'),
        meta: {
            title: 'Discussions',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'messages' },
            dataTablePage: true,
        },
        beforeEnter: FeatureMiddleware('INBOX'),
    },
    {
        path: '/inbox/announcements',
        name: 'inbox-announcements',
        component: () => import('@/components/inbox/announcements/AnnouncementsViewAll.vue'),
        middleware: [GateKeeperMiddleware],
        meta: {
            title: 'Announcements',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'messages' },
        },
        beforeEnter: FeatureMiddleware('INBOX'),
    },
    {
        path: '/inbox/announcements/course/:courseId/:type/:announcementId',
        name: 'announcement-view',
        component: () => import('@/components/inbox/announcements/AnnouncementView.vue'),
        meta: {
            title: 'Announcement',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'messages' },
        },
        beforeEnter: FeatureMiddleware('INBOX'),
    },
];
